import Postmate from 'postmate';
export class IframeParentCommnuicationService {
    InitCommunication(config) {
        window.handshake = new Postmate.Model(config);
    }
    SendMessageToParent(data) {
        window.handshake.then((parent) => {
            parent.emit('eIn_listener', data);
        });
    }
}
//# sourceMappingURL=IframeParentCommnuicationService.js.map